import { SVGProps, Ref, forwardRef } from 'react';

export const MaxSquareSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M12.218 8.275v.004a3.761 3.761 0 0 1 3.549 3.903 3.76 3.76 0 0 1-3.94 3.508 3.66 3.66 0 0 1-1.788-.637c-.32.32-.835.736-1.039.686-.426-.113-.925-2.276-.644-4.052.342-2.145 1.883-3.513 3.862-3.412"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.417 1A4.583 4.583 0 0 1 23 5.583v12.834A4.583 4.583 0 0 1 18.417 23H5.583A4.583 4.583 0 0 1 1 18.417V5.583A4.583 4.583 0 0 1 5.583 1zM12.12 4.667c-4.063 0-7.492 3.14-7.492 7.315 0 1.749.323 2.955.608 4.038.24.88.451 1.685.452 2.638.102 1.27 2.443.528 3.182-.422 1.169.844 1.841 1.055 3.288 1.055a7.26 7.26 0 0 0 5.112-2.145 7.24 7.24 0 0 0 2.102-5.125c0-4.058-3.186-7.354-7.252-7.354"
                fill="currentColor"
            />
        </g>
    </svg>
));
MaxSquareSolidSize24Glyph.displayName = 'MaxSquareSolidSize24Glyph';
